import React from 'react';
import { st, classes } from './ComplexAddress.st.css';
import ShortText from '../ShortText/ShortText';
const defaultOrder = [
    'streetLine1',
    'streetLine2',
    'city',
    'state',
    'postalCode',
    'country',
];
const jaOrder = [
    'country',
    'postalCode',
    'state',
    'city',
    'streetLine1',
    'streetLine2',
];
const ComplexAddressComponent = ({ onBlur, onChange, field: { externalId, renderInfo }, theme, locale, className, invalidMessage, disabled, inputRef, value = {
    country: '',
    state: '',
    city: '',
    streetLine1: '',
    streetLine2: '',
    postalCode: '',
}, }) => {
    const { country, state, city, streetLine1, streetLine2, postalCode } = value;
    const onValueBlur = () => {
        onBlur({ country, state, city, streetLine1, streetLine2, postalCode });
    };
    const onValueChange = (data) => {
        onChange(data);
    };
    const renderInput = (inputName, inputRenderInfo, inputValue, updateCallback) => {
        var _a;
        return inputRenderInfo ? (React.createElement("div", { className: classes.inputWrapper, key: `${externalId}-${inputName}-wrapper` },
            React.createElement(ShortText, { id: `${externalId}-${inputName}-input`, theme: theme, field: { externalId, renderInfo: inputRenderInfo }, onChange: (newValue) => updateCallback(newValue), onBlur: () => onValueBlur(), inputRef: (ref) => {
                    if (inputRef) {
                        inputRef(inputName, ref);
                    }
                }, className: classes.shortText, value: inputValue, required: (_a = inputRenderInfo === null || inputRenderInfo === void 0 ? void 0 : inputRenderInfo.validationProperties) === null || _a === void 0 ? void 0 : _a.required, disabled: disabled, invalidMessage: invalidMessage && invalidMessage instanceof Object
                    ? invalidMessage[inputName]
                    : undefined }))) : null;
    };
    const fieldsOrder = locale === 'ja' ? jaOrder : defaultOrder;
    return (React.createElement("div", { className: st(classes.root, {}, className), "data-hook": "complex-address-field" }, fieldsOrder.map((fieldId) => {
        var _a;
        const options = (_a = renderInfo === null || renderInfo === void 0 ? void 0 : renderInfo.displayProperties) === null || _a === void 0 ? void 0 : _a.multiLineAddressSettings;
        if (!options) {
            return null;
        }
        return renderInput(fieldId, options[fieldId], value[fieldId], (newValue) => {
            onValueChange(Object.assign({ country,
                state,
                city,
                streetLine1,
                streetLine2,
                postalCode }, { [fieldId]: newValue }));
        });
    })));
};
export default ComplexAddressComponent;
//# sourceMappingURL=ComplexAddress.js.map